<template>
  <div class="birthdayCardWrap fc afe">
      <textarea placeholder="请输入要填写的生日牌内容（14个字以内哦）..." v-model="cardTxt" maxlength="14" name="" id=""></textarea>
      <span>{{cardTxt.length}}/14</span>
  </div>
</template>

<script>
export default {
    data() {
        return {
            cardTxt: ""
        };
    },
    components: {

    },
    created() {

    },
    beforeDestroy(){
        this.setLocal("birthdayCard", this.cardTxt)
    },
    methods: {

    }

}

</script>
<style lang="scss">
.birthdayCardWrap {
    textarea {
        width: 100%;
        height: 200px;
        font-size: 30px;
        line-height: 40px;
        padding: 20px;
        box-sizing: border-box;
    }
    span {
        font-size: 30px;
        line-height: 60px;
        padding: 0 20px;
        color: #999;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/mall/birthdayCard.vue